export async function createTeam({ userIds, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/createTeam`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({ userIds }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to create team");
  }
  return data;
}
